import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom theme tokens (tailwind.css). tailwind-merge must know these are
 * colors / shadows, otherwise it mis-classifies e.g. `text-fg` (a color) as a
 * font-size and drops it when combined with `text-[30px]`.
 */
const colors = [
  'base-white',
  'base-black',
  'fg',
  'fg-secondary',
  'fg-tertiary',
  'fg-muted',
  'app',
  'surface',
  'muted',
  'muted-strong',
  'default',
  'strong',
  'neutral',
  'neutral-hover',
  'brand-solid',
  'brand-solid-hover',
  'brand-text',
];
const scale = (name: string, steps: string[]) => steps.map(s => `${name}-${s}`);
const allColors = [
  ...colors,
  ...scale('brand', [
    '25',
    '50',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '950',
  ]),
  ...scale('gray', ['25']),
  ...scale('error', ['50', '100', '500', '600', '700']),
  ...scale('success', ['50', '500', '600']),
  ...scale('warning', ['50', '500', '600']),
];

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: allColors,
      shadow: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
  },
});

/**
 * Class composer used by every Regask UI component (the Untitled UI idiom):
 * clsx resolves conditionals, tailwind-merge dedupes conflicting utilities so
 * a caller's `className` always wins over a component default.
 */
export const cx = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
